/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Lazy per-profile criteria spotlight for a search's evaluation.
 *
 * Canonical definition; ``app.schemas.arbitrator`` re-exports this class so
 * both route modules share one OpenAPI component.
 */
export interface CriteriaSummarySchema {
  profile_id: string;
  summary_text: string;
  generated_at: string;
  fresh: boolean;
}
